"use strict";

exports.__esModule = true;
exports.StripeChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = require("styled-components");
var _EventTimeline = require("../../EventTimeline");
var _PlantStateActivities = require("../../PlantStateActivities");
var _ChartCard = require("../common/ChartCard");
var _DeviceContext = require("../../Device/DeviceContext");
var _Time = require("../../Time");
var _DeviceCycleCollector = require("../../Device/DeviceCycleCollector");
var _DeviceCycleChart = require("../../Device/DeviceCycleChart");
var _ClassificationContext = require("../../Operator/ClassificationContext");
var _timelineDefinitions = require("../../Timeline/timelineDefinitions");
var _Timeline = require("../../Timeline");
var _getInstantaneousTimelineEvents = require("./getInstantaneousTimelineEvents");
var _helpers = require("../../InstantaneousEvent/helpers");
var _Core = require("../../Core");
var _common = require("../common");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _timeDefinitions = require("../../timeDefinitions");
var _describeReportingPeriod = require("./describeReportingPeriod");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _StripeChartElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a stripe chart for a particular device.
 */
var StripeChartElement = exports.StripeChartElement = (_dec = _PlantStateActivities.PlantStateActivitiesContext.withContext, _dec2 = _ConfigurableLayout.LayoutSettingsContext.withContext, _dec3 = _Core.SelectionContext.withContext, _dec4 = _Time.ReportingPeriodContext.withContext, _dec5 = _Time.TimeContext.withContext, _dec6 = _ClassificationContext.ClassificationContext.withContext, (0, _styledComponents.withTheme)(_class = _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = (_StripeChartElement = /*#__PURE__*/function (_Component) {
  function StripeChartElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(StripeChartElement, _Component);
  var _proto = StripeChartElement.prototype;
  // Legend for the card header: the plant's states in their timeline colours.
  _proto.getStatesLegend = function getStatesLegend() {
    var _this$props = this.props,
      plantStateActivities = _this$props.plantStateActivities,
      theme = _this$props.theme;
    var states = plantStateActivities && plantStateActivities.states || [];
    return states.map(function (state) {
      return {
        color: (0, _PlantStateActivities.getPlantStateColor)(theme, state.id),
        label: state.name || state.id
      };
    }).filter(function (item) {
      return item.color;
    }).slice(0, 7);
  };
  _proto.renderDeviceCycleChart = function renderDeviceCycleChart(_ref) {
    var _this = this;
    var _ref$timelineData = _ref.timelineData,
      timelineData = _ref$timelineData === void 0 ? [] : _ref$timelineData,
      reportingPeriod = _ref.reportingPeriod,
      instantaneousTimelineEvents = _ref.instantaneousTimelineEvents;
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height,
      showBrush = _this$props2.showBrush,
      hideXAxis = _this$props2.hideXAxis,
      selection = _this$props2.selection,
      initialBrushInterval = _this$props2.initialBrushInterval,
      classification = _this$props2.classification,
      brushEnableSnapToSelection = _this$props2.brushEnableSnapToSelection,
      brushEnableSnapToTimeline = _this$props2.brushEnableSnapToTimeline,
      brushEnableDragging = _this$props2.brushEnableDragging,
      brushEnableResize = _this$props2.brushEnableResize,
      path = _this$props2.path,
      dataRange = _this$props2.dataRange,
      showDivision = _this$props2.showDivision,
      showLabel = _this$props2.showLabel,
      time = _this$props2.time;
    var componentPath = (0, _ConfigurableLayout.getComponentPath)(path);
    var timezoneName = time && time.timezone && time.timezone.name;

    // brush interval only applies when dataRange is not SELECTION so this interval is the selection itself that
    // other charts then use in the code above when they are driven by the selection
    var brushInterval = initialBrushInterval;
    if (showBrush && selection && selection.selected.reportingPeriod) {
      brushInterval = selection.selected.reportingPeriod.interval;
    }
    return /*#__PURE__*/_react["default"].createElement(_ChartCard.ChartCard, {
      width: width,
      height: height,
      backgroundColor: this.props.backgroundColor,
      title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "StripeChartElement.card.title",
        defaultMessage: "State timeline"
      }),
      subtitle: (0, _describeReportingPeriod.describeReportingPeriod)(reportingPeriod, timezoneName),
      legend: this.getStatesLegend(),
      dataTestId: "StripeChartElement.Card"
    }, function (_ref2) {
      var innerWidth = _ref2.width,
        innerHeight = _ref2.height;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DeviceCycleChart.DeviceCycleChart, _extends({
        brushEnableSnapToSelection: brushEnableSnapToSelection,
        brushEnableSnapToTimeline: brushEnableSnapToTimeline,
        brushEnableDragging: brushEnableDragging,
        brushEnableResize: brushEnableResize
      }, (0, _common.getWidgetInteractionProps)(_this.props), (0, _common.getWidgetPositionProps)(_this.props), {
        brushSnapToMillis: (0, _timeDefinitions.getMinutesMillis)(15) // 15 minute snapping
        ,
        brushInterval: brushInterval,
        showBrush: showBrush,
        showDivision: showDivision,
        onBrushChange: function onBrushChange(brushInterval) {
          // update the context selection with the brushed interval
          if (selection) {
            selection.setSelection({
              reportingPeriod: {
                interval: brushInterval
              }
            }, componentPath);
          }
        },
        onBrushReset: function onBrushReset() {
          if (selection) {
            selection.resetSelection();
          }
        },
        interval: reportingPeriod.interval,
        timeline: timelineData,
        width: innerWidth,
        height: innerHeight,
        axis: !hideXAxis,
        instantaneousEventList: instantaneousTimelineEvents,
        onItemClick: function onItemClick(item) {
          if (classification) {
            classification.onSelect([item.interval]);
          }
        },
        path: path,
        dataRange: dataRange,
        showLabel: showLabel
      })), (!timelineData || timelineData.length === 0) && /*#__PURE__*/_react["default"].createElement(_ChartCard.EmptyTimelineNote, {
        height: innerHeight
      }));
    });
  };
  _proto.renderWithDeviceOrClassification = function renderWithDeviceOrClassification(targetReportingPeriod) {
    var _this2 = this;
    var _this$props3 = this.props,
      showTickets = _this$props3.showTickets,
      showAlerts = _this$props3.showAlerts,
      showComments = _this$props3.showComments,
      classification = _this$props3.classification,
      dataRange = _this$props3.dataRange;

    // With Classification
    if (classification && dataRange !== "SELECTION") {
      return /*#__PURE__*/_react["default"].createElement(_EventTimeline.EventTimelineController, {
        eventTypes: (0, _getInstantaneousTimelineEvents.getEventTypes)({
          showAlerts: showAlerts,
          showTickets: showTickets,
          showComments: showComments
        }),
        deviceList: [classification.device.uuid],
        start: new Date(classification.interval.startMillis).toISOString(),
        end: new Date(classification.interval.endMillis).toISOString()
      }, function (_ref3) {
        var data = _ref3.data;
        var instantaneousTimelineEvents = (0, _helpers.getInstantaneousTimelineEvents)({
          data: data,
          eventTypes: (0, _getInstantaneousTimelineEvents.getEventTypes)({
            showAlerts: showAlerts,
            showTickets: showTickets,
            showComments: showComments
          })
        });
        return _this2.renderDeviceCycleChart({
          timelineData: classification.cycles,
          reportingPeriod: targetReportingPeriod,
          instantaneousTimelineEvents: instantaneousTimelineEvents
        });
      });
    }

    // For a device
    return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Consumer, null, function (device) {
      return /*#__PURE__*/_react["default"].createElement(_DeviceCycleCollector.DeviceCycleCollector, {
        deviceUuid: device.uuid,
        interval: targetReportingPeriod.interval
      }, function (_ref4) {
        var data = _ref4.data;
        return _this2.renderDeviceCycleChart({
          timelineData: data,
          reportingPeriod: targetReportingPeriod
        });
      });
    });
  };
  _proto.renderWithTimeline = function renderWithTimeline(targetReportingPeriod, timeline) {
    var _this3 = this;
    return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Consumer, null, function (device) {
      return /*#__PURE__*/_react["default"].createElement(_Timeline.TimelineQueryController, {
        timelineName: timeline,
        query: {
          device: device.uuid
        },
        interval: targetReportingPeriod.interval
      }, function (_ref5) {
        var fetching = _ref5.fetching,
          data = _ref5.data,
          error = _ref5.error;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fetching && /*#__PURE__*/_react["default"].createElement("div", null), error && /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: error
        }), data && _this3.renderDeviceCycleChart({
          timelineData: data,
          reportingPeriod: targetReportingPeriod
        }));
      });
    });
  };
  _proto.render = function render() {
    var _this$props4 = this.props,
      reportingPeriod = _this$props4.reportingPeriod,
      selection = _this$props4.selection,
      timeline = _this$props4.timeline,
      dataRange = _this$props4.dataRange,
      layoutSettings = _this$props4.layoutSettings;
    var targetReportingPeriod = reportingPeriod;
    if (layoutSettings != null && layoutSettings.stripeChart.allowSelection && dataRange === "SELECTION" && selection && selection.selected.reportingPeriod) {
      targetReportingPeriod = selection.selected.reportingPeriod;
    }
    switch (timeline) {
      case _timelineDefinitions.TIME_SERIES_INSTANCE:
      case _timelineDefinitions.TIME_SERIES_PROCESS:
      case _timelineDefinitions.TIME_SERIES_SHIFT:
      case _timelineDefinitions.TIME_SERIES_KIND:
        return this.renderWithTimeline(targetReportingPeriod, timeline);
      default:
        return this.renderWithDeviceOrClassification(targetReportingPeriod);
    }
  };
  return StripeChartElement;
}(_react.Component), _StripeChartElement.defaultProps = {
  selection: undefined,
  reportingPeriod: undefined,
  time: undefined,
  classification: undefined,
  layoutSettings: undefined,
  plantStateActivities: undefined,
  theme: undefined
}, _StripeChartElement)) || _class) || _class) || _class) || _class) || _class) || _class) || _class);